import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import {
  AppState,
  Auth0Provider,
  Auth0ProviderOptions
} from '@auth0/auth0-react';

import Layout from '@/components/Layout';
import PublicESignSignerPage from '@/pages/Public/ESignSigner/PublicESignSignerPage';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import { RouteConfig } from '@/routes';
import { RoutePath } from '@/routes/RoutePath';

interface Auth0ProviderWithRedirectCallbackProps extends Auth0ProviderOptions {
  children: React.ReactNode;
}

const Auth0ProviderWithRedirectCallback: React.FC<
  Auth0ProviderWithRedirectCallbackProps
> = ({ children, ...props }) => {
  const navigate = useNavigate();
  const onRedirectCallback: (appState: AppState | undefined) => void = (
    appState
  ) => {
    navigate((appState && appState.returnTo) || window.location.pathname, {
      state: {
        isFirstLogin: true
      }
    });
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

function AuthenticatedAppRoutes() {
  return (
    <Auth0ProviderWithRedirectCallback
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      redirectUri={location.origin}
      audience={import.meta.env.VITE_AUTH0_AUDIENCE}
    >
      <Routes>
        <Route path={RoutePath.Unauthorized} element={<UnauthorizedPage />} />
        <Route
          path="*"
          element={
            <Layout>
              <RouteConfig />
            </Layout>
          }
        />
      </Routes>
    </Auth0ProviderWithRedirectCallback>
  );
}

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path={RoutePath.PublicESignSigner}
        element={<PublicESignSignerPage />}
      />
      <Route path="*" element={<AuthenticatedAppRoutes />} />
    </Routes>
  );
}
